import AddVoucher from '../../modules/add-voucher'
import VoucherValidateErrorForSignup from '../../components/modals/voucher-validate-error-for-signup'
import VoucherValidateErrorAfterLogin from '../../components/modals/voucher-validate-error-after-login'
import Login from '../../components/login'
import SubscriptionRepair from '../../containers/subscriptions/neon/subscription-repair'
import SubscriptionVoucherWarn from '../../containers/subscriptions/neon/subscription-voucher-warn'
import LoginRental from '../../components/login/login-rental'
import ProfilesManage from '../../modules/profiles/manage-profiles'
import ProfilesAdd from '../../modules/profiles/add-profiles'
import ProfilesEdit from '../../modules/profiles/edit-profiles'
import ProfilesSwitch from '../../modules/profiles/switch-profiles'
import RequestPasswordReset from '../../components/password-reset/request-password-reset'
import PasswordReset from '../../components/password-reset/password-reset'
import PinResetModel from '../../components/pin/pin-reset-model'
import UpdatePaymentDetails from '../../components/modals/update-payment-details'
import WelcomeBack from '../../components/subscriptions/neon/welcome-back'
import { MODALS, THEME_OPTIONS } from '../../constants'
import AddSubscriptionContents from '../../modules/add-subscription-modal/add-subscription-contents'
import AddPaymentCancelModalContent from '../../modules/shared/add-payment-cancel-modal-content/add-payment-cancel-modal-content'
import AddContentToListsModal from '../../modules/my-lists/modal-add-content-to-lists'
import ConfirmImportListModal from '../../modules/my-lists/preview-import-list/confirm-import-list-modal'
import {
  UpgradeSubscriptionModal,
  DowngradeSubscriptionModal
} from '../../modules/change-subscription'
import UserExistsModalContent
  from '../../modules/sign-up/components/user-exists-modal/user-exists-modal-content'
import RenameNamedList from '../../modules/my-lists/component-watchlist/components/rename-list-modal'
import ConfirmDeleteListModal from '../../modules/my-lists/component-watchlist/components/confirm-delete-list-modal'
import ShareListModal from '../../modules/my-lists/component-watchlist/components/share-list-modal'

const modalsParams = MODALS.qsParams

// Registry of routed modals to be rendered.
const modals = {
  // auth modals
  [modalsParams.addVoucher]: AddVoucher,
  [modalsParams.voucherValidateErrorForSignup]: VoucherValidateErrorForSignup,
  [modalsParams.voucherValidateErrorAfterLogin]: VoucherValidateErrorAfterLogin,
  [modalsParams.addSubscription]: AddSubscriptionContents,
  [modalsParams.upgradeSubscription]: UpgradeSubscriptionModal,
  [modalsParams.downgradeSubscription]: DowngradeSubscriptionModal,
  [modalsParams.login]: Login,
  // REMOVE ME - remove ALL old sign up models
  [modalsParams.subscriptionRepair]: SubscriptionRepair,
  [modalsParams.subscriptionVoucherWarn]: SubscriptionVoucherWarn,
  [modalsParams.loginRental]: LoginRental,
  [modalsParams.updatePaymentDetails]: UpdatePaymentDetails,
  [modalsParams.welcomeBack]: WelcomeBack,
  [modalsParams.renameNamedList]: RenameNamedList,
  [modalsParams.confirmDeleteList]: ConfirmDeleteListModal,
  [modalsParams.shareList]: ShareListModal,
  [modalsParams.signupTVODCancelAddPayment]: AddPaymentCancelModalContent,
  [modalsParams.addContentToLists]: AddContentToListsModal,
  [modalsParams.confirmImportList]: ConfirmImportListModal,
  // profiles modals
  [modalsParams.profilesManagement]: ProfilesManage,
  [modalsParams.profilesAdd]: ProfilesAdd,
  [modalsParams.profilesEdit]: ProfilesEdit,
  [modalsParams.profilesSwitch]: ProfilesSwitch,
  // password modals
  [modalsParams.passwordForgotten]: RequestPasswordReset,
  [modalsParams.passwordReset]: PasswordReset,
  // pin modals
  [modalsParams.pinForgotten]: PinResetModel,
  // user exists
  [modalsParams.userExists]: UserExistsModalContent
}

const modalTheme = {
  [modalsParams.login]: THEME_OPTIONS.dark,
  [modalsParams.passwordForgotten]: THEME_OPTIONS.dark,
  [modalsParams.passwordReset]: THEME_OPTIONS.dark,
  [modalsParams.loginRental]: THEME_OPTIONS.dark,
  [modalsParams.subscriptionRepair]: THEME_OPTIONS.dark,
  [modalsParams.subscriptionVoucherWarn]: THEME_OPTIONS.dark,
  [modalsParams.upgradeSubscription]: THEME_OPTIONS.dark,
  [modalsParams.downgradeSubscription]: THEME_OPTIONS.dark,
  [modalsParams.addSubscription]: THEME_OPTIONS.dark,
  [modalsParams.addVoucher]: THEME_OPTIONS.dark,
  [modalsParams.voucherValidateErrorForSignup]: THEME_OPTIONS.dark,
  [modalsParams.voucherValidateErrorAfterLogin]: THEME_OPTIONS.dark,
  [modalsParams.welcomeBack]: THEME_OPTIONS.dark,
  [modalsParams.signupTVODCancelAddPayment]: THEME_OPTIONS.dark,
  [modalsParams.addContentToLists]: THEME_OPTIONS.dark,
  [modalsParams.confirmImportList]: THEME_OPTIONS.dark,
  [modalsParams.userExists]: THEME_OPTIONS.dark,
  [modalsParams.renameNamedList]: THEME_OPTIONS.dark,
  [modalsParams.confirmDeleteList]: THEME_OPTIONS.dark,
  [modalsParams.shareList]: THEME_OPTIONS.dark,
  [modalsParams.updatePaymentDetails]: THEME_OPTIONS.dark
}

function getModalComponent(modal) {
  return modals[modal]
}

function getModalTheme(modal) {
  return modalTheme[modal] || THEME_OPTIONS.light
}

/**
 * modals with special handling in `layouts/routed-modal/routed-modal.jsx` are listed below
 */
const MODALS_NOT_SHOW_AGAIN_NAVIGATE_BACK = [
  modalsParams.loginRental,
  modalsParams.addContentToLists,
  modalsParams.renameNamedList,
  modalsParams.confirmDeleteList,
  modalsParams.confirmImportList,
  modalsParams.shareList
]
/**
 * Only include modals that truly should not affect the underlying screen.
 * These modals should not cause screen reloading/rerendering when opened or closed.
 */
const MODALS_DO_NOT_CAUSE_SCREEN_RELOAD = [
  modalsParams.addContentToLists,
  modalsParams.confirmDeleteList,
  modalsParams.shareList,
  modalsParams.confirmImportList
]
const MODALS_WITH_GRID_IMAGE_BACKGROUND = []
const MODALS_HIDE_CLOSE_BUTTON = []
const MODALS_SPECIAL_SIZE = { // generally one modal should exist in only one of FLEXIBLE/LARGE/FULL_SCREEN
  FLEXIBLE: [
    modalsParams.login,
    modalsParams.profilesManagement,
    modalsParams.profilesSwitch,
    modalsParams.passwordForgotten,
    modalsParams.passwordReset,
    modalsParams.loginRental,
    modalsParams.pinForgotten,
    modalsParams.userExists,
    modalsParams.welcomeBack,
    modalsParams.signupTVODCancelAddPayment,
    modalsParams.voucherValidateErrorForSignup
  ],
  LARGE: [
    modalsParams.profilesAdd,
    modalsParams.profilesEdit,
    modalsParams.shareList,
    modalsParams.addContentToLists,
    modalsParams.confirmImportList
  ],
  FULL_SCREEN: []
}

export {
  getModalComponent,
  getModalTheme,
  MODALS_NOT_SHOW_AGAIN_NAVIGATE_BACK,
  MODALS_DO_NOT_CAUSE_SCREEN_RELOAD,
  MODALS_WITH_GRID_IMAGE_BACKGROUND,
  MODALS_HIDE_CLOSE_BUTTON,
  MODALS_SPECIAL_SIZE
}
